import { createContext, useContext, useEffect, useMemo } from "react";
import { DEFAULT_BRAND, brandToCssVars } from "./tokens";

// F-MOTOR-RESERVAS.3.0.3 — Provedor de identidade visual.
// Injeta CSS variables em :root a partir dos tokens. Em F-SAAS.N, aceitará um
// `brand` sobrescrito pelo tenant resolvido no backend.

const BrandContext = createContext(DEFAULT_BRAND);

export function BrandProvider({ brand = DEFAULT_BRAND, children }) {
  const resolved = useMemo(() => ({ ...DEFAULT_BRAND, ...brand }), [brand]);

  useEffect(() => {
    const root = document.documentElement;
    const vars = brandToCssVars(resolved);
    const prev = {};
    for (const [k, v] of Object.entries(vars)) {
      prev[k] = root.style.getPropertyValue(k);
      root.style.setProperty(k, v);
    }
    return () => {
      for (const k of Object.keys(vars)) {
        if (prev[k]) root.style.setProperty(k, prev[k]);
        else root.style.removeProperty(k);
      }
    };
  }, [resolved]);

  return <BrandContext.Provider value={resolved}>{children}</BrandContext.Provider>;
}

export function useBrand() {
  return useContext(BrandContext);
}
